// extracted by mini-css-extract-plugin
module.exports = {"progress":"ProgressBar_progress__ykKgC","completed":"ProgressBar_completed__yaTRt"};